import { GivelifyLabel } from '@givelify/ui';
import { styled } from '@mui/material';

export const LoginTitle = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
        fontSize: 18,
        lineHeight: '24px',
        display: 'flex',
    },
}));
